import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PopoverService } from '../../../components/popover/popover.service';
import { NotificationsInboxService } from 'src/app/services/notifications-inbox.service';
import { ToolbarNotificationsDropdownComponent } from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';

@UntilDestroy()
@Component({
  selector: 'vex-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarNotificationsComponent implements OnInit {

  @ViewChild('originRef', { static: false, read: ElementRef }) originRef: ElementRef;

  dropdownOpen: boolean;
  unreadCount = 0;
  canAccessAlerts = false;

  constructor(private popover: PopoverService,
              private notificationsInbox: NotificationsInboxService,
              private cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.canAccessAlerts = this.notificationsInbox.canAccessAlerts();
    if (!this.canAccessAlerts) {
      return;
    }

    this.notificationsInbox.start();
    this.notificationsInbox.unreadCount$
      .pipe(untilDestroyed(this))
      .subscribe(count => {
        this.unreadCount = count;
        this.cd.markForCheck();
      });
  }

  showPopover() {
    if (!this.canAccessAlerts) {
      return;
    }

    this.dropdownOpen = true;
    this.notificationsInbox.markSeen();
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarNotificationsDropdownComponent,
      origin: this.originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
